module.exports = __webpack_public_path__ + "img/34.5.COD.7e4b7680.png";